<!-- Pre-start tutorial (въведение) -->
<script>
	import {
		doc,
		collection,
		addDoc,
		setDoc,
		getDoc,
		getDocs,
		updateDoc,
		onSnapshot,
		query,
		where,
		limit,
		deleteField,
		serverTimestamp,
		increment,
	} from "firebase/firestore";
	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	export let lang;
	export let gid;
	export let db;
	let tutorial = false;
	let expanded = true;

	const dispatch = createEventDispatcher();
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });

	async function loadTutorial() {
		// const taskRef = doc(db, "games", gid, "gamedata");
		const taskRef = doc(db, "games", gid, "gamedata", "tutorial");
		const taskRefSnap = await getDoc(taskRef);
		if (taskRefSnap.exists()) {
			tutorial = taskRefSnap.data();
			expanded = taskRefSnap.data().expand ? taskRefSnap.data().expand : false;

			// hideStartBtn();
		} else {
			console.log("No tutorial to be found! If needed, contact admin!");
		}
	}
	loadTutorial();

	// function hideStartBtn() {
	// 	const trigger = document.getElementById("game_tutorial");
	// 	const target = document.getElementById("game_start_button");
	// 	const observer = new MutationObserver(() => {
	// 		target.style.display = trigger.classList.contains("compressed")
	// 			? "none"
	// 			: "block";
	// 	});
	// 	observer.observe(trigger, {
	// 		attributes: true,
	// 		attributeFilter: ["class"],
	// 	});
	// }
</script>

{#if tutorial}
	{#if tutorial.customStyling}
		<style>
			* {
				transition: all 0.2s ease-in;
			}
		</style>
		{@html tutorial.customStyling}
	{/if}
	<div
		class={expanded
			? "pt-4 my-8 tutorial transition duration-300"
			: "py-4 my-8 tutorial transition duration-300 compressed"}
		id="game_tutorial"
	>
		<p class="mx-auto text-center">{ui.tutorial.intro}</p>
		<br />
		{@html tutorial.tutorial}
		{#if !expanded}
			<p
				class="absolute bottom-0 left-0 right-0 p-4 font-normal text-center cursor-pointer tutorial-expand"
				style="max-width:none"
				on:click={() => {
					expanded = !expanded;
				}}
			>
				{ui.tutorial.expand}
			</p>
		{/if}
	</div>
{/if}

<style>
	.tutorial {
		/* border: 2px solid #f7db00; */
		position: relative;
		height: auto;
	}
	.tutorial.compressed {
		height: 300px;
		overflow: hidden;
	}
	.tutorial-expand {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: #093986;
	}
	.tutorial-expand:before {
		width: 100%;
		height: 50px;
		background-image: linear-gradient(transparent, #093986);
		content: "";
		position: absolute;
		top: -50px;
		left: 0;
		right: 0;
	}
</style>
